<script>
import ExcelExport from '@/data/excel/excel-export.js'

export default {
  data() {
    return {
      exportProgress: {
        show: false,
        phase: 'building',
        current: 0,
        total: 0,
        error: null,
      },
      isExporting: false,
    }
  },
  methods: {
    closeExportProgress() {
      this.exportProgress.show = false
      this.exportProgress.error = null
    },
    updateExportProgress(current, total) {
      this.exportProgress.current = current
      this.exportProgress.total = total
    },
    async runExcelExport({ datas, fileName, buildSheetData }) {
      if (!datas.length) {
        window.alert('沒有可匯出的資料')
        return
      }

      this.isExporting = true
      this.exportProgress = {
        show: true,
        phase: 'building',
        current: 0,
        total: datas.length,
        error: null,
      }

      await this.$nextTick()

      try {
        const sheetData = await buildSheetData(datas, (current, total) => {
          this.updateExportProgress(current, total)
        })

        this.exportProgress.phase = 'writing'
        this.exportProgress.current = datas.length
        await this.$nextTick()

        await ExcelExport.exportSheet(sheetData, fileName)

        this.exportProgress.phase = 'downloading'
        this.exportProgress.show = false
      } catch (err) {
        this.exportProgress.error = err && err.message ? err.message : String(err)
      } finally {
        this.isExporting = false
      }
    },
  },
}
</script>
